/**
 * Pickup operatori (PICKUP_OPERATOR) kontraktlari — punktga tushgan buyurtmalar.
 *
 * Operator FAQAT o'z punktiga (User.pickupPointId) biriktirilgan pickup
 * buyurtmalarni ko'radi. Amallar: "tayyor" (buyerga xabar — pickupReadyAt) va
 * "mijoz oldi" (MarketplaceOrder.status = COMPLETED + xabar). Pul → STRING.
 */
import { z } from 'zod';
export const pickupOperatorQuerySchema = z.object({
    status: z.enum(['active', 'collected', 'all']).optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=marketplace-pickup-operator.schema.js.map